import { render, staticRenderFns } from "./splitForm.vue?vue&type=template&id=15632aa6"
import script from "./splitForm.vue?vue&type=script&lang=js"
export * from "./splitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports